// Só registra esta rota se está em modo desenvolvimento
export default process.env.NODE_ENV === 'development' ? {
    name: 'dev',
    path: '/dev',
    component: () => import(/* webpackChunkName: "dev" */ '@/views/dev/Dev.vue'),
} : {}